import apiClient from "utils/api";
import { getIdToken } from "../authentication"


export const findAllProposals = async (dispatch, token) => {
  return new Promise(async (resolve, reject) => {
    try {
       
        let result = await apiClient.service("v1/training/proposals").find({
          query: {
            firebaseToken: token,
          },
        });

        dispatch({
          type: "UpdateProposals",
          payload: result.data,
        });

        resolve(result);
    } catch (e) {
      reject(e);
    }
  });
};

export const createNewProposal = async (dispatch, location, token) => {
  return new Promise(async (resolve, reject) => {
    try {
       
        let result = await apiClient
          .service("v1/training/proposals")
          .create(location, {
            query: {
              firebaseToken: token,
            },
          });

        dispatch({
          type: "AddProposal",
          payload: result,
        });

        resolve(result);
    } catch (e) {
      reject(e);
    }
  });
};

export const editProposal = async (dispatch, data, locationId, token) => {
  return new Promise(async (resolve, reject) => {
    try {
       

        let updatedProposal = await apiClient
          .service("v1/training/proposals")
          .patch(locationId, data, {
            query: {
              firebaseToken: token,
            },
          });

        dispatch({
          type: "EditProposal",
          payload: {
            proposalId: locationId,
            data: updatedProposal,
          },
        });

        resolve();
    } catch (e) {
      reject(e);
    }
  });
};

export const deleteProposal = async (dispatch, proposalId, token) => {
  return new Promise(async (resolve, reject) => {
    try {
       
        let result = await apiClient
          .service("v1/training/proposals")
          .remove(proposalId, {
            query: {
              firebaseToken: token,
            },
          });

        dispatch({
          type: "RemoveProposal",
          payload: result,
        });

        resolve(result);
    } catch (e) {
      reject(e);
    }
  });
};

export const getSingleProposal = async (proposalId, token) => {
  return new Promise(async (resolve, reject) => {
    try {
       

        let result = await apiClient
          .service("v1/training/proposals")
          .get(proposalId, {
            query: {
              firebaseToken: token,
            },
          });

        resolve(result);
    } catch (e) {
      reject(e);
    }
  });
};
